import React from 'react';
import PropTypes from 'prop-types';
import filter from 'lodash/filter';
import { renderText } from 'stream-chat-react';
const MessageLink = ({ node, ...props }) => (
  <a className="message-link" {...props} />
);

const MessageUnorderedList = ({ node, ...props }) => (
  <ul className="default-list-style" {...props} />
);

const MessageNumberedList = ({ node, ...props }) => (
  <ol className="default-list-style" {...props} />
);

const detectLineBreaks = (text = '') => {
  // First, add &nbsp; to all line breaks
  const withBreaks = text.replace(/\n/gi, '&nbsp;\n');

  // Then, ensure there's a double line break after the last list item
  return withBreaks.replace(/((?:\d+\.|[-*])\s+[^\n]+)(?:\n|$)/g, '$1\r\n\r\n');
};

const MessageParagraph = ({ node, children, ...props }) => {
  return (
    <p className="message-paragraph" {...props}>
      {children}
    </p>
  );
};

export const MessageText = ({ id, text }) => {
  return (
    <div data-message-id={id} className="text-gray-900">
      {renderText(detectLineBreaks(text), [], {
        getRemarkPlugins: (plugins) => filter(plugins, (plugin) => 'keepLineBreaksPlugin' !== plugin.name),
        customMarkDownRenderers: {
          a: MessageLink,
          ul: MessageUnorderedList,
          ol: MessageNumberedList,
          p: MessageParagraph
        }
      })}
    </div>
  );
};

MessageText.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string
};
